import { createContext } from 'react';

import {
  NozomiVantageAssetCounts,
  RefreshStatus,
} from '@totem/components/administration/reconciliation/nozomi/vantage/types';

interface Context {
  loading: boolean;
  data: NozomiVantageAssetCounts | null;
  // Refresh jobs in progress, keyed by sensor site id or ALL_SENSORS.
  refreshing: Record<string, RefreshStatus>;
  onReload: () => void;
  onRefreshCounts: (siteId?: string) => void;
}

export default createContext<Context>({
  loading: false,
  data: null,
  refreshing: {},
  onReload: () => {},
  onRefreshCounts: () => {},
});
